module.exports = __webpack_public_path__ + "static/media/banana.8632acf6.png";